<template>
    <div class="famous-pedia-create-dyln-list">
        <van-collapse class="layout-cfc-collapse" v-model="activeDaYunNames" v-bind:border="false" @change="changeDaYun">
            <van-collapse-item class="layout-cfc-item" v-bind:border="false" v-for="dayunData of curPediaDayunLiunianList" v-bind:key="dayunData.name" v-bind:name='dayunData.name' v-bind:id="dayunData.name">
                <div class="layout-cfc-title" slot="title">
                    <i class="iconfont cfc-icon" v-bind:class="{'icon-sanjiao': !dayunData || !dayunData.edited, 'icon-sanjiao-shi': dayunData && dayunData.edited}"></i>{{dayunData.year+'-'+(dayunData.year+(dayunData.liunian.length-1))}}  {{dayunData.ganzhi+(dayunData.before ? '' : '大运')}}
                </div>
                <i slot="right-icon"></i>
                <div class="layout-cfc-content">
                    <van-collapse class="layout-cfc-sub-collapse" v-model="activeLiuNianNames" v-bind:border="false" @change="changeLiuNian">
                        <van-collapse-item class="layout-cfcsc-item" v-bind:border="false" v-for="liunianData of dayunData.liunian" v-bind:key="liunianData.year" v-bind:name="liunianData.name" v-bind:id="liunianData.name" v-show="showDom">
                            <div class="layout-cfcsc-title" slot="title">
                                <i class="iconfont cfcsc-icon" v-bind:class="{'icon-circle': !liunianData || !liunianData.edited, 'icon-circle-shi': liunianData && liunianData.edited}"></i>{{liunianData.year}}	{{liunianData.ganzhi}}流年
                            </div>
                            <i slot="right-icon">
                                <!-- 编辑:修改模式 -->
                                <span v-if="curPediaEditType == 'modify'" class="layout-cfcsc-title-edit-box">
                                    <span class="layout-cfcsc-title-edit" v-if="activeLiuNianNames.indexOf(liunianData.name) != -1 && !modifyStatusData[liunianData.name]" @click.stop="clickModify(liunianData.name, liunianData.content)">修改</span>
                                </span>
                                <!-- 编辑:编辑模式 -->
                            </i>
                            <div v-if="liunianData.content != '' || curPediaEditType == 'edit'" class="layout-cfc-subc-paragraph layout-fpc-ln-subc-paragraph">
                                <comment-edit-panel
                                    v-bind:fromPage="'famousCreateList'"
                                    v-bind:className="modifyStatusData[liunianData.name] ? 'famous-pc-edit-panel-modify' : 'famous-pc-edit-panel'"
                                    v-bind:parentData="{'dayun': dayunData.year, 'liunian': liunianData.year}"
                                    v-bind:textValue="liunianData.content"
                                    v-bind:textId="liunianData.name"
                                    v-bind:hideShowAll="true"
                                    v-bind:saveFunc="clickSaveLiuNian"
                                    v-bind:hideEdit="curPediaEditType != 'edit'">
                                </comment-edit-panel>
                            </div>
                            <!-- 编辑:修改模式 -->
                            <div v-if="liunianData.content == '' && curPediaEditType == 'modify'">
                                <p>暂无内容</p>
                            </div>
                            <div v-if="curPediaEditType == 'modify' && modifyStatusData[liunianData.name]" class="layout-cfc-subc-paragraph layout-fpc-ln-subc-paragraph">
                                <textarea class="layout-cep-textarea" v-bind:class="{'layout-cep-textarea-focus' : focusedData[liunianData.name]}" @focus="focusTextArea(liunianData.name)" @blur="blurTextArea(liunianData.name)" v-model="textStringData[liunianData.name]" name="base" id="" cols="30" rows="4" placeholder="请输入" maxlength="3000"></textarea>
                                <div class="layout-cfcsc-title-edit-div">
                                    <span class="layout-cfcsc-title-edit" @click.stop="clickSaveModify(liunianData.name, dayunData.year, liunianData.year)">保存</span>
                                    <span class="layout-cfcsc-title-edit" @click.stop="clickCancelModify(liunianData.name)">取消</span>
                                </div>
                            </div>
                        </van-collapse-item>
                    </van-collapse>
                </div>
            </van-collapse-item>
        </van-collapse>
    </div>
</template>

<script>
import CommentEditPanel from '../../layouts/comment/CommentEditPanel.vue'
import { COMMENT_DOM, FAMOUS_DOM } from '../../modules/dom';
import { UA } from '../../modules/utils';
export default {
    name: 'FamousEditList',
    components: { CommentEditPanel },
    computed: {
        curPediaEditType() {
            return this.$store.state.famouspedia.curPediaEditType;
        },
        curPediaDayunLiunianList() {
            return this.$store.state.famouspedia.curPediaDayunLiunianList;
        },
        activeDaYunNames: {
            get() {
                return this.$store.state.comment.activeDaYunNames;
            },
            set(value) {
                this.$store.state.comment.activeDaYunNames = value;
            }
        },
        activeLiuNianNames: {
            get() {
                return this.$store.state.comment.activeLiuNianNames;
            },
            set(value) {
                this.$store.state.comment.activeLiuNianNames = value;
            }
        }
    },
    data() {
        return {
            tempDaYunActiveNames: [],
            tempLiuNianActiveNames: [],
            modifyStatusData: {},
            textStringData: {},
            focusedData: {},
            showDom: true
        }
    },
    methods: {
        changeDaYun(activeNames) {
            if(activeNames.length > this.tempDaYunActiveNames.length) {
                var me = this, curName = activeNames[activeNames.length - 1];
                this.$store.dispatch('minifatefortune/triggerFortuneItemClick', curName);
                setTimeout(() => {
                    FAMOUS_DOM.updateFamousEditFormScrollTop(curName);
                    me.$store.state.comment.curActiveName = curName;
                }, 200);
            }
            this.tempDaYunActiveNames = activeNames;
            console.log('changeDaYun', activeNames, this.activeDaYunNames)
        },
        changeLiuNian(activeNames) {
            if(activeNames.length > this.tempLiuNianActiveNames.length) {
                var me = this, curName = activeNames[activeNames.length - 1];
                this.$store.dispatch('minifatefortune/triggerFortuneItemClick', curName);
                setTimeout(() => {
                    FAMOUS_DOM.updateFamousEditFormScrollTop(curName);
                    me.$store.state.comment.curActiveName = curName;
                }, 200);
            }
            this.tempLiuNianActiveNames = activeNames;
            console.log('changeLiuNian', activeNames, this.activeLiuNianNames)
        },
        clickSaveDayun(text, parentData, cb) {
            var me = this;
            var params = {
                type: 'dayun', key: 'content', parentData: parentData, text: text, cb: cb, 
                failCb: function(errMsg) {
                    me.$toast(errMsg);
                }
            }
            this.$store.dispatch('famouspedia/updateBaikePipan', params);
        },
        clickSaveLiuNian(text, parentData, cb) {
            var me = this;
            var params = {
                type: 'liunian', key: 'content', parentData: parentData, text: text, cb: cb,
                failCb: function(errMsg) {
                    me.$toast(errMsg);
                }
            }
            this.$store.dispatch('famouspedia/updateBaikePipan', params);
        },
        clickModify(curName, curContent) {
            if(this.modifyStatusData[curName]) {
                return;
            }
            this.textStringData[curName] = curContent;
            // 触发修改输入框的展示
            this.modifyStatusData[curName] = true;
            this.updateDom();
        },
        clickCancelModify(curName) {
            if(!this.modifyStatusData[curName]) {
                return;
            }
            this.textStringData[curName] = '';
            // 触发修改输入框的展示
            this.modifyStatusData[curName] = false;
            this.updateDom();
        },
        updateDom() {
            this.showDom = false;
            var me = this;
            setTimeout(() => {
                me.showDom = true;
            }, 10);
        },
        focusTextArea(curName) {
            this.focusedData[curName] = true;
            setTimeout(() => {
                if(UA.isIphone()) {
                    FAMOUS_DOM.updateFamousEditFormTextAreaScrollTop(curName, true);
                }else {
                    FAMOUS_DOM.updateFamousEditFormTextAreaScrollTop(curName, false);
                }
            }, 20);
        },
        blurTextArea(curName, dyYear, lnYear) {
            this.focusedData[curName] = false;
            setTimeout(() => {
                FAMOUS_DOM.updateFamousFormStyle();
                FAMOUS_DOM.updateFamousEditFormScrollTop(curName);
            }, 20);
        },
        clickSaveModify(curName, dyYear, lnYear) {
            var me = this;
            this.$store.dispatch('famouspedia/updateBaikePipan', {
                type: 'liunian',
                key: 'content',
                parentData: {'dayun': dyYear, 'liunian': lnYear},
                text: this.textStringData[curName],
                cb: function() {
                    me.modifyStatusData[curName] = false;
                    me.updateDom();
                    // me.$store.dispatch('comment/updateLiuNianNames', curName);
                },
                failCb: function() {
                    me.$toast('修改失败，请再次尝试！')
                    me.modifyStatusData[curName] = false;
                    me.updateDom();
                    // me.$store.dispatch('comment/updateLiuNianNames', curName);
                }
            });
        }
    }
}
</script>